import { render, staticRenderFns } from "./FamilyGroupManager.vue?vue&type=template&id=3dd7e1aa&scoped=true&lang=pug"
import script from "./FamilyGroupManager.vue?vue&type=script&lang=js"
export * from "./FamilyGroupManager.vue?vue&type=script&lang=js"
import style0 from "./FamilyGroupManager.vue?vue&type=style&index=0&id=3dd7e1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7e1aa",
  null
  
)

export default component.exports